var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pe-box"},[_c('div',{staticClass:"im-title"},[_vm._v("\n    日本語でユーザー対応\n  ")]),_vm._v(" "),_c('div',{staticClass:"im-demo"},[_vm._v("\n    サポートデスクは日本語で対応。旅行・出張・駐在・留学等の目的で中国に滞在する日本人の“困った”を一気に解決します。\n  ")]),_vm._v(" "),_c('div',{staticClass:"im-image"},[_c('img',{attrs:{"src":_vm.im}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-368ced81","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pe-home/modules/im-introduction.vue
// module id = null
// module chunks = 